// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"8a4efcf9","453":"c24e4e57"}[chunkId] + ".chunk.js";
};